// src/services/bookingService.js
import api from './api';

const bookingService = {
  /**
   * Récupérer les créneaux disponibles pour une date donnée
   */
  async getAvailableSlots(salonId, date) {
    try {
      const response = await api.get(`/reservations/availability/${salonId}`, {
        params: { date }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur récupération créneaux:', error);
      throw error;
    }
  },

  /**
   * ✅ CRÉER UNE RÉSERVATION MULTI-SERVICES (PRINCIPAL)
   */
  async createReservation(bookingData) {
    try {
      const response = await api.post('/reservations/multi', bookingData);
      return {
        success: true,
        data: response.data.reservation,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur de connexion au serveur'
      };
    }
  },

  /**
   * Alias pour compatibilité
   */
  async createMultiServiceReservation(bookingData) {
    return this.createReservation(bookingData);
  },

  /**
   * Vérifier si un créneau est disponible
   */
  async checkSlotCapacity(salonId, date, time) {
    try {
      const response = await api.get('/reservations/check-capacity', {
        params: { salonId, date, time }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur vérification capacité:', error);
      throw error;
    }
  },

  /**
   * ✅ RÉCUPÉRER MES RÉSERVATIONS (CÔTÉ CLIENT)
   */
  async getMyReservations() {
    try {
      const response = await api.get('/reservations/my-reservations');
      return {
        success: true,
        reservations: response.data.reservations || []
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur serveur',
        reservations: []
      };
    }
  },

  /**
   * ✅ ANNULER UNE RÉSERVATION
   */
  async cancelReservation(reservationId) {
    try {
      const response = await api.put(`/reservations/${reservationId}/cancel`);
      return {
        success: true,
        message: response.data.message,
        reservation: response.data.reservation
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur serveur'
      };
    }
  },

  /**
   * ✅ RÉCUPÉRER LES INFOS ESCROW D'UNE RÉSERVATION
   * Pour afficher le montant de l'acompte au client
   */
  async getEscrow(reservationId) {
    try {
      const response = await api.get(`/reservations/${reservationId}/escrow`);
      return {
        success: true,
        escrow: response.data.escrow
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur serveur',
        escrow: null
      };
    }
  },

  /**
   * ✅ SIMULER LE PAIEMENT DE L'ACOMPTE (WAVE / ORANGE MONEY)
   */
  async payDeposit(reservationId, paymentMode, clientPhone) {
    try {
      const response = await api.post(`/reservations/${reservationId}/pay-deposit`, {
        payment_mode: paymentMode,
        client_phone: clientPhone
      });
      return {
        success: true,
        message: response.data.message,
        escrow: response.data.escrow
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur serveur'
      };
    }
  },

  /**
   * Récupérer toutes les dates fermées d'un salon
   */
  async getClosedDates(salonId, days = 120) {
    try {
      const response = await api.get(`/public/salons/${salonId}/closed-dates`, {
        params: { days }
      });
      return {
        success: true,
        closedDates: response.data.closedDates || []
      };
    } catch (error) {
      return { success: false, closedDates: [] };
    }
  },

  /**
   * Vérifier si une date précise est fermée
   */
  async checkDateClosed(salonId, date) {
    try {
      const response = await api.get(`/public/salons/${salonId}/check-date`, {
        params: { date }
      });
      return {
        success:   true,
        is_closed: response.data.is_closed,
        message:   response.data.message
      };
    } catch (error) {
      return { success: false, is_closed: false };
    }
  }
};

export default bookingService;
